<template>
    <div v-if="loading" class="space-y-4">
        <Message status="info">{{ loadingMessage }}</Message>
    </div>
    <div v-if="!loading && isEmpty" class="space-y-4">
        <EmptyState>
            <template #description>
                {{ empyStateDescription }}
            </template>
            <template #call-to-action>
                <LinkButton
                    size="Base"
                    variant="Info-Strong"
                    :disabled-explanation="createDisabledExplanation"
                    :to="createLink"
                >
                    <template #icon>
                        <PlusIcon class="size-5" />
                    </template>
                    {{ createLabel }}
                </LinkButton>
            </template>
        </EmptyState>
    </div>
    <div v-if="!loading && !isEmpty" class="space-y-4">
        <slot />
    </div>
</template>
<script setup lang="ts">
import LinkButton from '@/components/Button/LinkButton.vue';
import EmptyState from '@/components/EmptyState/EmptyState.vue';
import PlusIcon from '@/components/Icon/PlusIcon.vue';
import Message from '@/components/Message/Message.vue';
import { RouteLocationRaw } from 'vue-router';

defineProps<{
    loading: boolean;
    isEmpty: boolean;
    loadingMessage: string;
    empyStateDescription: string;
    createDisabledExplanation?: string;
    createLink: RouteLocationRaw;
    createLabel: string;
}>();
</script>
